import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type SpecificationsAccordionContentClasses = 'category' | 'tableRow' | 'tableCell' | 'nestedCaption';

const specificationsAccordionContentStyles = makeStyles<ISpcTheme, SpecificationsAccordionContentClasses>(
  theme => ({
    category: {
      fontFamily: theme.typography.fontFamily2,
      color: theme.palette.common.black,
      textAlign: 'left',
    },
    tableRow: {
      backgroundColor: theme.palette.background.paper,
    },
    tableCell: {
      padding: '8px 0',
      paddingRight: 30,
      width: '66%',
      wordBreak: 'break-word',
      borderBottom: `1px solid ${theme.palette.text.disabled}`,
    },
    nestedCaption: {
      paddingLeft: 20,
    },
  }),
  { name: 'Customise_SpecificationsAccordionContent' },
);

export default specificationsAccordionContentStyles;
